import { cn } from "@/lib/utils";

interface ProfileBadgeProps {
  name: string;
  className?: string;
}

/** Neutral mono tag for a scoring profile — matches the cartographic rail tags. */
export function ProfileBadge({ name, className }: ProfileBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-border bg-secondary px-2 py-0.5 font-mono text-[10px] font-medium text-muted-foreground",
        className,
      )}
    >
      {name}
    </span>
  );
}
